import * as React from 'react';
import { useSelector } from 'react-redux';

import { getIsActive } from '~/renderer/store/receipt/selectors';

import GroupedItem from './GroupedItem';
import { ReceiptItems as ReceiptItemsWrapper, ReceiptItemsTable } from './Receipt.style';
import ReceiptItem from './ReceiptItem';
import { useScrollListToBottom } from './use-scroll-list-to-bottom';

import type { SaleLine } from '~/renderer/store/receipt/types';

interface ReceiptTableProps {
  saleLines: SaleLine[];
  hasUntaxedItems: boolean;
}

const ReceiptTable: React.FunctionComponent<ReceiptTableProps> = ({
  saleLines,
  hasUntaxedItems,
}) => {
  const tableRef = React.useRef<HTMLTableSectionElement | undefined>();
  const isActive = useSelector(getIsActive);

  useScrollListToBottom({ trigger: saleLines, ref: tableRef, isActive });
  return (
    <ReceiptItemsWrapper>
      <ReceiptItemsTable data-testid="receipt-items-table">
        <tbody
          data-testid="items-table-body"
          ref={tableRef as React.RefObject<HTMLTableSectionElement>}
        >
          {saleLines.map((saleLine, index) => {
            if (saleLine.workOrder) {
              return (
                <GroupedItem
                  key={saleLine.saleLineID}
                  lineNumber={index}
                  saleLine={saleLine}
                  hasUntaxedItems={hasUntaxedItems}
                />
              );
            }
            const description = saleLine.Item?.description ?? '';
            return (
              <ReceiptItem
                key={saleLine.saleLineID}
                lineNumber={index}
                saleLine={saleLine}
                hasUntaxedItems={hasUntaxedItems}
                description={description}
              />
            );
          })}
        </tbody>
      </ReceiptItemsTable>
    </ReceiptItemsWrapper>
  );
};

export default ReceiptTable;
